import { forwardRef } from "react";

import type { BalanceBoosterMultiplierHandle, BalanceBoosterMultiplierProps } from "./BalanceBoosterMultiplier.types";
import { BoosterVariant, getVariantComponent } from "./variants";

/** Balance Booster Multiplier - supports multiple team variants */
export const BalanceBoosterMultiplier = forwardRef<BalanceBoosterMultiplierHandle, BalanceBoosterMultiplierProps>(
  (
    {
      variant = BoosterVariant.REWARD_PLATFORM,
      aviosAmount,
      defaultSelectedBoostId,
      onBoostSelect,
      onBoostRemove,
      onError,
      onEligibilityChange,
      className,
      disabled = false,
    },
    ref,
  ) => {
    const VariantComponent = getVariantComponent(variant);

    /* eslint-disable react/jsx-handler-names */
    return (
      <VariantComponent
        ref={ref}
        aviosAmount={aviosAmount}
        defaultSelectedBoostId={defaultSelectedBoostId}
        onBoostSelect={onBoostSelect}
        onBoostRemove={onBoostRemove}
        onError={onError}
        onEligibilityChange={onEligibilityChange}
        className={className}
        disabled={disabled}
      />
    );
    /* eslint-enable react/jsx-handler-names */
  },
);

BalanceBoosterMultiplier.displayName = "BalanceBoosterMultiplier";
